
export default class Promotion{
    constructor(){
        this._type = -1;
        this._name = "";

        this._parent = null;
    }

    init(data){

    }

    setParent(parent){
        this._parent = parent;
    }

    getValue(){
        
    }
}